import React from "react";
import StringField from "./StringField";
import MediaField from "./MediaField";
import ListField from "./ListField";

const MEDIA_KEYS = new Set(["image", "src", "audio", "trailer", "poster", "still"]);

function humanise(key) {
  return key.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}

export default function ObjectField({ value, onChange, path, onUploadAsset }) {
  const keys = Object.keys(value);
  return (
    <div className="space-y-4">
      {keys.map((k) => (
        <ObjectFieldRow
          key={k}
          k={k}
          v={value[k]}
          path={path}
          parent={value}
          onChange={onChange}
          onUploadAsset={onUploadAsset}
        />
      ))}
    </div>
  );
}

function ObjectFieldRow({ k, v, path, parent, onChange, onUploadAsset }) {
  const subPath = [...path, k];
  const update = (newV) => onChange({ ...parent, [k]: newV });
  const isMedia = MEDIA_KEYS.has(k) && typeof v === "string";
  return (
    <div data-testid={`obj-field-${subPath.join(".")}`}>
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#a3a3a3] block mb-2">
        {humanise(k)}
      </label>
      <ObjectFieldValue
        v={v}
        update={update}
        subPath={subPath}
        isMedia={isMedia}
        onUploadAsset={onUploadAsset}
      />
    </div>
  );
}

function ObjectFieldValue({ v, update, subPath, isMedia, onUploadAsset }) {
  if (Array.isArray(v)) {
    return React.createElement(ListField, {
      value: v, onChange: update, path: subPath, onUploadAsset,
    });
  }
  if (typeof v === "object" && v !== null) {
    return (
      <div className="border border-white/10 p-4">
        {React.createElement(ObjectField, {
          value: v, onChange: update, path: subPath, onUploadAsset,
        })}
      </div>
    );
  }
  if (isMedia) {
    return <MediaField value={v} onChange={update} path={subPath} onUploadAsset={onUploadAsset} />;
  }
  return <StringField value={String(v ?? "")} onChange={update} path={subPath} />;
}
